<script lang="ts" setup>
import { ButtonComponent, DialogModal, SwitchComponent } from '@metapic-apps/shared'
import { computed, ref } from 'vue'
import { useStore } from 'vuex'

import { localStorageService } from '@/lib/services/localStorage.services'
import BoxComponent from '@/ui-library/atoms/BoxComponent/BoxComponent.vue'
import FlexComponent from '@/ui-library/atoms/FlexComponent/FlexComponent.vue'
import TypographyComponent from '@/ui-library/atoms/TypographyComponent/TypographyComponent.vue'

const props = defineProps<{ isLoading: boolean; onSubmit: (value: boolean) => void }>()
const emits = defineEmits(['onCancel', 'onConfirm'])
const isOpen = defineModel<boolean>('modelValue', { default: false })
const store = useStore()
const userId = computed(() => store.getters['user/userId'])
const localStorageKey = localStorageService.composeKey('shouldDisableMoveToDoneWarningPopup', userId.value)
const shouldShowDialogWindow = ref(Boolean(localStorageService.getItem<boolean>(localStorageKey)))

const handleCancel = () => {
  emits('onCancel')
}

const handleConfirm = () => {
  emits('onConfirm')
  props.onSubmit(shouldShowDialogWindow.value)
}
</script>
<template>
  <DialogModal v-model="isOpen" :width="480">
    <template #header>
      <TypographyComponent variant="headline-medium">Move to done</TypographyComponent>
    </template>
    <template #default>
      <BoxComponent :mt="24" :mb="32">
        <TypographyComponent variant="body-large">
          This creator has fixed fee assigned, moving to done will add this payment to their account. Do you want to proceed?
        </TypographyComponent>
        <BoxComponent :mt="24">
          <SwitchComponent v-model="shouldShowDialogWindow" title="Do not ask me again, always move" />
        </BoxComponent>
      </BoxComponent>
    </template>
    <template #footer>
      <FlexComponent justify="flex-end" :gap="16">
        <ButtonComponent variant="text" @click="handleCancel"> Cancel </ButtonComponent>
        <ButtonComponent variant="accent" :is-loading="props.isLoading" @click="handleConfirm">Move</ButtonComponent>
      </FlexComponent>
    </template>
  </DialogModal>
</template>
